/**
 * Created by hj on 2017/9/4.
 */
import {config, request, objectSerial} from 'Utils';

/**
 * 产品列表
 * @param param
 * @returns {*}
 */
export function getProductList(param) {
    return request(`${config.server}/api/v1/dms/product/productListPc`, {
        method: 'post',
        body: param
    });
}

export function getProductListPcBatch(param) {
    return request(`${config.server}/api/v1/dms/product/productListPcBatch`, {
        method: 'post',
        body: param
    });
}

export function getProductListEn(param) {
    return request(`${config.server}/api/v1/dms/product/productListPcEn`, {
        method: 'post',
        body: param
    });
}

/*加入收藏夹*/
export function addProductEnFavorites(param) {
    return request(`${config.server}/api/v1/dms/product/addProductEnFavorites`, {
        method: 'post',
        body: param
    });
}

/*物料大类筛选接口*/
export function proBigNameScreening(param) {
    return request(`${config.server}/api/v1/dms/product/main${objectSerial(param)}`);
}

/*物料中类筛选接口*/
export function proMiddleNameScreening(param) {
    return request(`${config.server}/api/v1/dms/product/middle/${param}`);
}

/*明细类筛选接口*/
export function proDetailNameScreening(param) {
    return request(`${config.server}/api/v1/dms/product/details/${param}`);
}


/*加入收藏夹*/
export function addFavoritesList(param) {
    return request(`${config.server}/api/v1/dms/collect/insertCollectHaveSpec`, {
        method: 'post',
        body: param
    });
}

/* 移出收藏夹
    param {
      productId // 产品ID
    }
 */
export function deleteFavoritesList(param) {
    return request(`${config.server}/api/v1/dms/collect/delete`, {
        method: 'post',
        body: param
    });
}

/*加入购物车*/
export function addShoppingCarList(param) {
    return request(`${config.server}/api/v1/dms/shoppingCart/insertPc`, {
        method: 'post',
        body: param
    });
}

/* 批量上传资料接口
 * param
  {
    ids  // 产品ids,用逗号隔开
    fileId  // 附件ID,用逗号隔开
  }
*/
export function uploadInformation(param) {
    return request(`${config.server}/api/v1/dms/product/addFiles?${objectSerial(param)}`, {});
}

/*批量清除资料接口*/
export function batchRemove(param) {
    return request(`${config.server}/api/v1/dms/product/deleteFiles?${objectSerial(param)}`, {});
}


/**
 * 查询人员列表
 * @param param
 * @returns {*}
 */
export function getempList(param) {
    /*
     param: {
     kw:''
     p:1,
     s:10
     }
    * */
    return request(`${config.server}/api/v1/dms/employee/list`, {
        method: 'post',
        body: param
    });
}

/**
 * 产品详情 get
 * @param param
 * @returns {*}
 */

/*export function getProductDetails(id) {
    return request(`${config.server}/api/v1/dms/product/details?id=` + id);
}*/

export function getProductDetails(param) {
    return request(`${config.server}/api/v1/dms/product/proDetail`, {
        method: 'post',
        body: param
    });
}


/*本体附件接口*/
export function fetchSpecList(param) {
    return request(`${config.server}/api/v1/dms/product/category/${param}`);
}

/*物流点选择*/
export function LogisticsDetail(param) {
    return request(`${config.server}/api/v1/dms/tgStock/orderStock`, {
        method: 'post',
        body: param
    });
}


/*附件上传列表接口*/
export function getFileList(param) {
    return request(`${config.server}/api/v1/dms/commonAttachUpload/getList?${objectSerial(param)}`, {
        method: 'post',
        body: param,
    });
}


/**
 * 出入库列表
 * @param param
 * @returns {*}
 */
export function getWarehouseInventoryQueryList(param) {
    return request(`${config.server}/api/v1/dms/storageOutInRecord/listByPage`, {
        method: 'post',
        body: param
    });
}


/**
 * 库存列表
 * @param param
 * @returns {*}
 */
export function getStockList(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/listByPage`, {
        method: 'post',
        body: param
    });
}

/**
 * 收发存报表
 * @param param
 * @returns {*}
 */
export function getStoreOutInList(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/StoreOutInByPage`, {
        method: 'post',
        body: param
    });
}

/**
 * 库存列表汇总金额
 * @param param
 * @returns {*}
 */export function getStockListAmount(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/listByPageAmount`, {
        method: 'post',
        body: {...param},
    });
}

/**
 * 事务管理--库存列表
 * @param param
 * @returns {*}
 */
export function getStockList2(param) {
    return request(`${config.server}/api/v1/dms/storageOutInRecord/listByPage`, {
        method: 'post',
        body: param
    });
}


/**
 * 二级产品列表
 * @param param
 * @returns {*}
 */
export function getProductList2(param) {
    return request(`${config.server}/api/v1/dms/trans/otherPro/listByPage`, {
        method: 'post',
        body: param
    });
}

export function getProductListIds(param) {
    return request(`${config.server}/api/v1/dms/trans/otherPro/DmsAndOtherProList`, {
        method: 'post',
        body: param
    });
}

/**
 * 删除其他产品
 * @param param
 * @returns {*}
 */
export function del(param) {
    return request(`${config.server}/api/v1/dms/trans/otherPro/deleteOtherpro`, {
        method: 'post',
        body: param
    });
}

/**
 * 删除其他产品
 * @param param
 * @returns {*}
 */
export function del2(param) {
    return request(`${config.server}/api/v1/dms/dmsTianSubStore/deleteList`, {
        method: 'post',
        body: param
    });
}


/**
 * 按规格查询产品列表
 * @param param
 * @returns {*}
 */
export function getlistPcSpec(param) {
    /*
     param: {
     kw:''
     p:1,
     s:10
     }
    * */
    return request(`${config.server}/api/v1/dms/product/listPcSpec`, {
        method: 'post',
        body: param
    });
}

/**
 * 产品 批量上架
 * @param param
 * @returns {*}
 */
export function setProductUp(param) {
    return request(`${config.server}/api/v1/dms/product/up`, {
        method: 'post',
        body: param
    });
}

/**
 * 产品 批量下架
 * @param param
 * @returns {*}
 */
export function setProductDown(param) {
    return request(`${config.server}/api/v1/dms/product/down`, {
        method: 'post',
        body: param
    });
}

/**
 * 产品 新建
 * @param param
 * @returns {*}
 */

/*export function saveProductAdd(param) {
  return request(`${config.server}/api/v1/dms/product/create`, {
    method: 'post',
    body: param
  });
}*/

/**
 * 产品 编辑
 * @param param
 * @returns {*}
 */
export function saveProductEdit(param) {
    return request(`${config.server}/api/v1/dms/product/update`, {
        method: 'post',
        body: param
    });
}

/**
 * 产品规格
 * @param param
 * @returns {*}
 */
export function getProductSpec(productTypeId) {
    return request(`${config.server}/api/v1/dms/spec/specList`, {
        method: 'post',
        body: {
            active: 1,
            productTypeId: productTypeId
        }
    });
}

/**
 * 产品分类 get
 * @param param
 * @returns {*}
 */
export function getProductCategory() {
    return request(`${config.server}/api/v1/dms/category/listTree`, {
        method: 'get'
    });
}

/**
 * 产品品牌 get
 * @param param
 * @returns {*}
 */
export function getProductBrand() {
    return request(`${config.server}/api/v1/dms/productBrand/list`, {
        method: 'post',
        body: {
            p: 1,
            s: 1000000,
            active: 1
        }
    });
}

/**
 * 数据字典 get
 * @param param
 * @returns {*}
 */
export function getDictionay(key) {
    return request(`${config.server}/api/v1/dms/dictionayDependent/sKeylist?sKey=${key}`, {
        method: 'get'
    });
}

/**
 * 获取产品评论列表 get
 * @param param
 * @returns {*}
 */
export function getProductComment(productId) {
    return request(`${config.server}/api/v1/dms/product/getProductEevaluation?productId=${productId}`, {
        method: 'get'
    });
}

/**
 * 统计评论数量 get
 * @param param
 * @returns {*}
 */
export function getProductCommentCount(productId) {
    return request(`${config.server}/api/v1/dms/product/getProductEevaluationCount?productId=${productId}`, {
        method: 'get'
    });
}

/**
 * 获取产品规格的库存与价格 post
 * @param param
 * @returns {*}
 */
export function refreshPriceStockFn(params) {
    return request(`${config.server}/api/v1/dms/product/specInventory`, {
        method: 'post',
        body: params
    });
}

/**
 * 判断规格组合是否可以删除 post
 * @param param
 * @returns {*}
 */
export function getMatrixForDelete(id) {
    return request(`${config.server}/api/v1/dms/product/detailsSpecMatrix?id=${id}`, {
        method: 'get'
    });
}

/**
 * 查询组织树 包含渠道\区域\门店
 * @param param
 * @returns {*}
 */
export function getOrgTree() {
    return request(`${config.server}/api/v1/dms/treeRelation/tgTree`, {
        method: 'get'
    });
}


/*客户列表*/
export function customerList() {
    return request(`${config.server}/api/v1/dms/employee/customerList`, {
        method: 'get'
    });
}


/*生成订单渠道*/
export function fetchChannelList(param) {
    return request(`${config.server}/api/v1/dms/homePage/channel`, {
        method: 'get'
    });
}


// /*生成订单渠道*/
// export function fetchChannelList2(param) {
//   return request(`${config.server}/api/v1/dms/dmsPurchase/contractType/55`, {
//     method: 'get'
//   });
// }

/*获取子库列表*/
export function getSubStoreList(param) {
    return request(`${config.server}/api/v1/dms/dmsTianSubStore/listByPage`, {
        method: 'post',
        body: {...param},
    });
}


/*新增子库存*/
export function add(param) {
    return request(`${config.server}/api/v1/dms/dmsTianSubStore/insert`, {
        method: 'post',
        body: param,
    });
}

export function getDetails(param) {
    return request(`${config.server}/api/v1/dms/dmsTianSubStore/listOne`, {
        // method: 'post',
        body: param,
    });
}

/* 调整库存 */

export function tiaozhengAdd(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/subStoreChange`, {
        method: 'post',
        body: param,
    });
}

/* 子库转移 */
export function transfersubStore(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/transfersubStore`, {
        method: 'post',
        body: param,
    });
}

/* 杂项入库 */
export function sundryInStorage(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/insertStorageList`, {
        method: 'post',
        body: param,
    });
}

/* 杂项出库 */
export function sundryOutStorage(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/outStorageList`, {
        method: 'post',
        body: param,
    });
}

/* 设置安全库存 */
export function createSafetyStore(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/createSafetyStore`, {
        method: 'post',
        body: param,
    });
}

/* 根据选型获取列表 */
export function initForList(param) {
    return request(`${config.server}/api/v1/dms/product/pcSelectList`, {
        method: 'post',
        body: param,
    });
}

/* 根据明细类查询id */
export function findId(param) {
    return request(`${config.server}/api/v1/dms/product/categoryCode?code=${param}`, {
        method: 'get',
    });
}

/*  */
export function getSendNo() {
    return request(`${config.server}/api/v1/dms/storageOutInRecord/createSendNo`, {
        method: 'get',
    });
}

/* 删除安全库存 */
export function deleteAllId(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/deleteList`, {
        method: 'post',
        body: param,
    });
}

/* 设置安全库存 */
export function setAllId(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/createSafetyStore`, {
        method: 'post',
        body: param,
    });
}

/* 重置 */
export function reSetAll(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/updateList`, {
        method: 'post',
        body: param,
    });
}

/* 新增安全库存 */
export function insertAll(param) {
    return request(`${config.server}/api/v1/dms/dmsTianGoodsStore/insertList`, {
        method: 'post',
        body: param,
    });
}

/** 本体（规格）集合
 * param
 *  {
 *    proCategoryId: 11251
 *  }
 *  */
export function getProductSpecListByBenti(param) {
    return request(`${config.server}/api/v1/dms/product/getProductSpecListByBenti`, {
        method: 'get',
        body: param,
    });
}

/** 本体规格从属关系
 * param
 *  {
 *    proCategoryId: 11251
 *  }
 *  */
export function getProductSpecListByBentiBelong(param) {
    return request(`${config.server}/api/v1/dms/product/getProductSpecListByBentiBelong`, {
        method: 'get',
        body: param,
    });
}

/** 附件规格从属关系
 * param
 *  {
 *    categoryId: 607045
 *  }
 *  */
export function getSpecListByFujianBelong(param) {
    return request(`${config.server}/api/v1/dms/product/getSpecListByFujianBelong`, {
        method: 'get',
        body: param,
    });
}

/** 规格从属关系（产品管理 详情页使用）
 *  */
export function proDetailBelong(categoryId) {
    return request(`${config.server}/api/v1/dms/product/categoryBelong/${categoryId}`, {
        method: 'get',
    });
}

/** 附件（规格）集合
 * param
 *  {
 *    proCategoryId: 11251,11252
 *  }
 *  */
export function getProductSpecListByFujian(param) {
    return request(`${config.server}/api/v1/dms/product/getProductSpecListByFujian`, {
        method: 'get',
        body: param,
    });
}

/** 根据分类查询附件规格集合
 * param
 *  {
 *    categoryId: 11251
 *  }
 *  */
export function getSpecListByFujian(param) {
    return request(`${config.server}/api/v1/dms/product/getSpecListByFujian`, {
        method: 'get',
        body: param,
    });
}

/** 产品及本体规格选型
 * param
 *  1、查询产品详情
 *  {
 *    id: 2646 // 默认产品id
 *  }
 *  2、通过规格型号查询物料编码
 *  {
 *      "fujianMsg": [{
          "id": 30225412,
          "num": null,
          "categoryId": 11251,
          "propertyNum": "EDGZDY",
          "requiredFlag": null,
          "propertyName": "额定工作电压",
          "checked": false,
          "propertyCategoryCode": "本体",
          "propertyDesc": "AC380V",
          "propertyDescName": null,
          "itemList": null
        }]
 *  }
 *
 *  */
export function getProductSpecByBenti(param) {
    return request(`${config.server}/api/v1/dms/product/getProductSpecByBenti`, {
        method: 'post',
        body: param,
    });
}

/** 默认附件规格
 * param
 *  {
 *    partCategoryId: 11251 // 所选附件分类id
 *  }
 *  */
export function getProductSpecByFujian(param) {
    return request(`${config.server}/api/v1/dms/product/getProductSpecByFujian`, {
        method: 'post',
        body: param,
    });
}



// WEBPACK FOOTER //
// ./src/service/product/index.js